import * as types from './mutation-types'

const state = {
  abilities: [],
}

const mutations = {
  [types.USER_SET_ABILITIES](state, Abilities)
  {
    state.abilities = Abilities
  },
}

export default {
  state,
  mutations,
}